module.exports = __webpack_public_path__ + "media/images/tax_return-73d6f16a0d5b514d049800a76d05cdc7.svg";